module.exports = __webpack_public_path__ + "img/占位图.aadb8baa.png";